export enum ETipoWidget {
  Valor = 1,
  Lista = 2,
  Grafico = 3,
  Outro = 4,
}
